// mutations
const SET_RESPINJAMAN = (state, payload) => {
  state.res_pinjaman = payload;
};
const SET_NOA = (state, payload) => {
  state.noa = payload;
};
const SET_FILTER = (state, payload) => {
  state.filter = payload;
};
const SET_MUTATION = (state, payload) => {
  state.nospp = payload;
};
const SET_REYMUTASIPINJAMAN = (state, payload) => {
  state.res_mutasiPinjaman = payload;
};
const SET_MASTERPINJAM = (state, payload) => {
  state.data_pinjam = payload;
};
export default {
  SET_RESPINJAMAN,
  SET_NOA,
  SET_FILTER,
  SET_MUTATION,
  SET_REYMUTASIPINJAMAN,
  SET_MASTERPINJAM
};
